export default __webpack_public_path__ + "static/media/music.cb125444.jpg";